<template>
  <div class="p-6">
    <div v-if="loading" class="flex justify-center mt-10">
      <vs-spinner />
    </div>

    <vx-card v-else title="My Consultant Profile" subtitle="View and manage your public data">
      <div class="vx-row">
        
        <!-- Profile Image -->
        <div class="vx-col w-full sm:w-1/3 text-center mb-6">
          <vs-avatar 
            size="120px" 
            :src="consultant.profile_image_url ? 'https://parser.ai.getboarded.com' + consultant.profile_image_url : ''" 
          />
          <h3 class="mt-4">{{ consultant.name }}</h3>
          <p class="text-primary">{{ consultant.email }}</p>
        </div>

        <!-- Details Form (Read Only for now, easily changeable to editable) -->
        <div class="vx-col w-full sm:w-2/3">
          
          <div class="vx-row mb-4">
            <div class="vx-col w-full sm:w-1/2">
              <vs-input label="Contact Number" v-model="consultant.contact_no" class="w-full" disabled />
            </div>
            <div class="vx-col w-full sm:w-1/2 mt-4 sm:mt-0">
              <vs-input label="Hourly Rate ($)" v-model="consultant.hourly_rate" class="w-full" disabled />
            </div>
          </div>

          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <vs-input label="LinkedIn URL" v-model="consultant.linkedin_url" class="w-full" disabled />
            </div>
          </div>

          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <label class="vs-input--label">Professional Bio</label>
              <vs-textarea v-model="consultant.professional_bio" disabled />
            </div>
          </div>
          
          <!-- Tags / Skills -->
          <div class="mt-6">
            <h6>Specializations</h6>
            <div class="flex flex-wrap mt-2">
              <vs-chip color="primary" v-for="(spec, index) in consultant.specializations" :key="index">
                {{ spec }}
              </vs-chip>
            </div>
          </div>

          <div class="mt-6">
            <h6>Skills</h6>
            <div class="flex flex-wrap mt-2">
              <vs-chip color="success" v-for="(skill, index) in consultant.skills" :key="index">
                {{ skill }}
              </vs-chip>
            </div>
          </div>

          <!-- Edit Button for later -->
          <div class="mt-8 flex justify-end">
             <vs-button color="primary" type="border" icon="icon-edit" icon-pack="feather">Edit Profile</vs-button>
          </div>

        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      consultant: {},
      loading: true
    };
  },
  mounted() {
    // Fetch user data from local storage where we saved it upon login
    const storedData = localStorage.getItem('consultantData');
    if (storedData) {
      this.consultant = JSON.parse(storedData);
      this.loading = false;
    } else {
      // Not logged in! Send back to login
      this.$router.push('/user/auth/login');
    }
  }
};
</script>